var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info" },
    [
      _c(
        "el-form",
        {
          ref: "infoForm",
          staticClass: "info-form",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c("el-form-item"),
          _c(
            "el-form-item",
            { attrs: { label: "用户头像" } },
            [
              _c("el-image", {
                staticStyle: {
                  width: "120px",
                  height: "120px",
                  cursor: "pointer",
                },
                attrs: { src: _vm.form.headImg },
                on: {
                  click: function ($event) {
                    return _vm.look(_vm.form.headImg)
                  },
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "用户ID" } }, [
            _vm._v(" " + _vm._s(_vm.form.uid || "--") + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "用户昵称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                attrs: { maxlength: "10", "show-word-limit": "" },
                on: { change: _vm.updateName },
                model: {
                  value: _vm.form.nickName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "nickName", $$v)
                  },
                  expression: "form.nickName",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "手机号码", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.phone || "--") + " "),
          ]),
          _c("el-form-item", { attrs: { label: " OPENID", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.openId || "--") + " "),
          ]),
          _c("el-form-item", { attrs: { label: "用户等级", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.vipLabel || "--") + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "用户推荐人ID", prop: "name" } },
            [_vm._v(" " + _vm._s(_vm.form.referrerId || "--") + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: " 可提现佣金", prop: "name" } },
            [
              _vm._v(
                " " +
                  _vm._s(Number(_vm.form.commission).toFixed(2) || "--") +
                  " "
              ),
            ]
          ),
          _c("el-form-item", { attrs: { label: "加入时间", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.inTime || "--") + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "最近访问时间", prop: "name" } },
            [_vm._v(" " + _vm._s(_vm.form.lastActiveTime || "--") + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }